import { CSSProperties } from "react";

type TooltipRow = {
  label: string;
  value: string | number;
};

type KpiHoverTooltipProps = {
  x: number;
  y: number;
  title: string;
  rows: TooltipRow[];
};

// Fixed-position dark tooltip used to reveal a breakdown on chart hover.
export const KpiHoverTooltip = ({ x, y, title, rows }: KpiHoverTooltipProps) => {
  const style: CSSProperties = {
    position: 'fixed',
    left: x + 14,
    top: y + 14,
    zIndex: 1000,
    background: '#0f1f2b',
    color: '#ffffff',
    borderRadius: '10px',
    padding: '10px 14px',
    minWidth: '170px',
    boxShadow: '0 10px 24px rgba(0,0,0,0.28)',
    pointerEvents: 'none'
  };

  return (
    <div style={style}>
      <div style={{ fontSize: 'var(--fs-small)', fontWeight: 700, marginBottom: '6px', color: '#cfe3ea', textTransform: 'uppercase', letterSpacing: '0.02em' }}>
        {title}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        {rows.map((row) => (
          <div key={row.label} style={{ display: 'flex', justifyContent: 'space-between', gap: '18px', fontSize: '0.8125rem' }}>
            <span>{row.label}</span>
            <span style={{ fontWeight: 700 }}>{row.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
